import React from "react";

import { Link } from "react-router-dom";

import { Stack, Flex, Image, Button, Text } from "@chakra-ui/react";

import useTranslations from "../../../hooks/useTranslations";
import useStore from "../../../store";

import ReportLayout from "../layout/ReportLayout";

import { ReportFragment } from "../../../graphql/generated/definitions";

import LeavingReportScreenIllustration from '../../../assets/leaving_report_screen.png';

export default function LeavingPage({ report }: { report: ReportFragment }) {
  const t = useTranslations();
  const resetCurrentStep = useStore((state) => state.report.resetCurrentStep);

  return (
    <ReportLayout canLeave={false}>
      <Flex
        direction="column"
        flexGrow={1}
        h="full"
        bgColor="primary.50"
        py={["8", "24"]}
        px={["4", "16", "20", "36"]}
        overflowY="auto"
      >
        <Flex
          direction="column"
          flexGrow={1}
          bgColor="white"
          w="full"
          h="full"
          rounded="md"
          shadow="md"
          alignItems="center"
          justify="space-evenly"
        >
          <Image maxW="100%" w="400px" h="300px" src={LeavingReportScreenIllustration} />
          <Stack direction="column" spacing={["4", "6"]}>
          <Text
            textAlign="center"
            fontSize="4xl"
            fontWeight="bold"
            color="brand"
          >
            {t("reports.leaving.answerSavedSuccessfully")}
          </Text>
          <Text textAlign="center">
            {t("reports.leaving.goBackWhenYouWant")}
          </Text>
          </Stack>
          <Stack direction={["column", "row"]} spacing={["4", "6"]}>
            <Button
              onClick={() => resetCurrentStep(report)}
              size="lg"
              colorScheme="primary"
            >
              {t("reports.leaving.resume")}
            </Button>

            <Button as={Link} to="/" size="lg" variant="outline">
              {t("reports.leaving.backToDashboard")}
            </Button>
          </Stack>
        </Flex>
      </Flex>
    </ReportLayout>
  );
}
